import { render, staticRenderFns } from "./AuctionFeeListTable.vue?vue&type=template&id=8bb248cc&"
import script from "./AuctionFeeListTable.vue?vue&type=script&lang=js&"
export * from "./AuctionFeeListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports